// extracted by mini-css-extract-plugin
export var productImage = "_kk-1";
export var viewLink = "_kk-2";
export var wishlistItem = "_kk-0";